import styled from "styled-components";

export const StyledLogo = styled.img`
  height: ${({ height }) => height || "50px"};
  cursor: ${({ onClick }) => (onClick ? "pointer" : "default")};
`;
